// HelpSupport.js - MAIN COMPONENT
// Is file ko apne App.js mein import karein

import React, { useState } from 'react';

// Import all child components
import SupportCards from '../../../../components/Admin/Help&Support/SupportCards/SupportCards';
import RecentTickets from '../../../../components/Admin/Help&Support/RecentTickets/RecentTickets';
import CreateTicket from '../../../../components/Admin/Help&Support/CreateTicket/CreateTicket';
import LiveChat from '../../../../components/Admin/Help&Support/LiveChat/LiveChat';
import Documentation from '../../../../components/Admin/Help&Support/Documentation/Documentation';

// Import main CSS
import '../../../../assests/css/admin/Help&Support/HelpSupport.css';

const HelpSupport = () => {
  // State to manage which view is active
  const [activeView, setActiveView] = useState('main');

  // Handler functions
  const handleCreateTicket = () => {
    setActiveView('createTicket');
  };

  const handleStartChat = () => {
    setActiveView('liveChat');
  };

  const handleViewDocs = () => {
    setActiveView('documentation');
  };

  const handleViewAll = () => {
    alert('Showing all tickets...');
  };

  const handleBackToMain = () => {
    setActiveView('main');
  };

  return (
    <>
  
   
    <div className="AdminHelpSupport-wrapper">
      {/* Main View - Default */}
      {activeView === 'main' && (
        <>
          <div className="AdminHelpSupport-header">
            <h1 className="AdminHelpSupport-title">Help & Support</h1>
            <p className="AdminHelpSupport-subtitle">
              Find answers, manage tickets, or contact our support team directly.
            </p>
          </div>

          {/* 3 Support Cards */}
          <SupportCards
            onCreateTicket={handleCreateTicket}
            onStartChat={handleStartChat}
            onViewDocs={handleViewDocs}
          />

          {/* Recent Tickets Table */}
          <RecentTickets onViewAll={handleViewAll} />

          {/* Bottom Section: Still Need Help + FAQ */}
         
        </>
      )}

      {/* Create Ticket View */}
      {activeView === 'createTicket' && (
        <CreateTicket onBack={handleBackToMain} />
      )}

      {/* Live Chat View */}
      {activeView === 'liveChat' && (
        <LiveChat onBack={handleBackToMain} />
      )}

      {/* Documentation View */}
      {activeView === 'documentation' && (
        <Documentation onBack={handleBackToMain} />
      )}
    </div>
   
     </>
  );
};

export default HelpSupport;